import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import DrivingLicenseBookletForm from './form';
import {
  NewPersonVM,
  AccordionDrivingLicenseBookletForm,
} from 'shell/components/shared/sipo-person-form/new-person';

const DrivingLicenseBookletComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldDrivingLicenseBookletChange = useEventCallback(
    (
      key: keyof AccordionDrivingLicenseBookletForm,
      value: AccordionDrivingLicenseBookletForm[keyof AccordionDrivingLicenseBookletForm]
    ) => {
      formContext.setFieldValue('drivingLicenseBooklet', {
        ...formContext.values.drivingLicenseBooklet,
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-driving-License-booklet-content"
        id="panel-person-driving-License-booklet-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Patente/Libretto</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <DrivingLicenseBookletForm
          values={formContext.values.drivingLicenseBooklet}
          onChange={onFieldDrivingLicenseBookletChange}
          errors={
            formContext.errors
              ?.drivingLicenseBooklet as FormikErrors<AccordionDrivingLicenseBookletForm>
          }
          touched={
            formContext.touched
              ?.drivingLicenseBooklet as unknown as FormikTouched<AccordionDrivingLicenseBookletForm>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

DrivingLicenseBookletComponent.displayName = 'Accordion Driving License Booklet component';

const DrivingLicenseBooklet = memo(DrivingLicenseBookletComponent);

export default DrivingLicenseBooklet;
